import { Link } from "react-router-dom";
import { Card, Button, Ratio } from "react-bootstrap";
import styles from "./styles.module.css";

/* Normalize vendor HTML -> plain text so weights/sizes are consistent */
const htmlToText = (html) => {
  if (!html) return "";
  // SSR-safe
  if (typeof window === "undefined") {
    return String(html).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }
  const div = document.createElement("div");
  div.innerHTML = html;
  return (div.textContent || div.innerText || "").trim();
};

const formatNGN = (value) => {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `₦${n.toLocaleString()}`;
  }
};

const ProductCard = ({ item }) => {
  const tokenString = localStorage.getItem("token");
  const token = tokenString ? JSON.parse(tokenString) : null;
  const tokenReady = token && token.role && token.role.id !== undefined;

  const price =
    tokenReady && [1, 2, 3, 4].includes(token.role.id) ? item?.price : item?.gen_price;

  return (
    <Link to={`/detail_page/${item.id}`} className={styles.cardLink} state={{ item }}>
      <Card className={`${styles.card} shadow-sm h-100`}>
        <Ratio aspectRatio="4x3" className={styles.imgWrap}>
          <Card.Img
            src={item?.thumbnail}
            alt={item?.title || "Product"}
            className={styles.img}
          />
        </Ratio>

        <Card.Body className={`${styles.body} d-flex flex-column`}>
          <Card.Title className={styles.title}>{item?.title || ""}</Card.Title>

          {/* Consistent weight/size across all items */}
          <Card.Text className={styles.desc}>{htmlToText(item?.description || "")}</Card.Text>
        </Card.Body>

        <div className={styles.separator} />

        <Card.Footer className={styles.footer}>
          <div className={styles.price}>{formatNGN(price)}</div>
          <Button variant="primary" className={styles.btn}>
            Shop Now
          </Button>
        </Card.Footer>
      </Card>
    </Link>
  );
};

export default ProductCard;
